import { PrivateUserInfo } from "../user";
import { IConverter, TSnapshot } from "./generics";

export const privateUserConverter: IConverter<PrivateUserInfo> =   {
  toFirestore(user: PrivateUserInfo) {
    return {
      ...user,
    };
  },
  fromFirestore(snapshot: TSnapshot ): PrivateUserInfo {
    const data = snapshot.data() as PrivateUserInfo;
    return {
      id: snapshot.id,
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      role: data?.role,
      permissions: data?.permissions,
      documents: data?.documents,
      disabled: data?.disabled,
      emailVerified: data?.emailVerified,
      displayName: data?.firstName + " " + data?.lastName,
      needsOnboarding: data?.needsOnboarding,
      onboardingCompletedAt: data?.onboardingCompletedAt,
      needsPasswordReset: data?.needsPasswordReset,
      passwordResetAt: data?.passwordResetAt,
      lastLoginAt: data?.lastLoginAt,
      lastPasswordResetRequestAt: data?.lastPasswordResetRequestAt,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
      needsInitialPasswordSet: data?.needsInitialPasswordSet,
      initialPasswordSetAt: data?.initialPasswordSetAt,
      lastVerificationEmailRequestAt: data?.lastVerificationEmailRequestAt,
      lastSignInLinkRequestAt: data?.lastSignInLinkRequestAt,
      meetingBaasCalendarUuid: data?.meetingBaasCalendarUuid,
      profilePicture: data?.profilePicture,
    };
  },
};
